module.exports = __webpack_public_path__ + "static/media/1.7019913f.mp3";